import { translate } from '@thoughtspot/i18n';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useTitle } from 'react-use';
export const useDocumentTitle = (params) => {
    var _a;
    const { companyTitle, title, customRouteMatches } = params;
    const [documentTitleProps, setDocumentTitleProps] = useState({
        companyTitle,
        title,
        customRouteMatches,
    });
    const setTitle = (title) => {
        if (title && !_.isEqual(documentTitleProps.title, title)) {
            setDocumentTitleProps(prevState => ({
                ...prevState,
                title,
            }));
        }
    };
    const setcustomRouteMatches = (customRouteMatches) => {
        if (!_.isEqual(documentTitleProps.customRouteMatches, customRouteMatches)) {
            setDocumentTitleProps(prevState => ({
                ...prevState,
                customRouteMatches,
            }));
        }
    };
    useEffect(() => {
        var _a;
        if (documentTitleProps.customRouteMatches &&
            documentTitleProps.customRouteMatches.length > 0) {
            setTitle(translate((_a = documentTitleProps.customRouteMatches[0]) === null || _a === void 0 ? void 0 : _a.title));
        }
    }, [documentTitleProps.customRouteMatches]);
    useTitle(documentTitleProps.title
        ? translate('DYNAMIC_PAGE_TITLE', {
            currentPage: documentTitleProps.title,
            companyTitle: documentTitleProps.companyTitle,
        })
        : (_a = documentTitleProps.companyTitle) !== null && _a !== void 0 ? _a : document.title, {
        restoreOnUnmount: true,
    });
    return {
        documentTitleProps,
        setDocumentTitle: setTitle,
        setcustomRouteMatches,
    };
};
//# sourceMappingURL=use-document-title-hook.js.map